export default {
  meta: {
    title: '加盟意向-详情',
    url: '/join/detail', // 埋点字段，上报归属的模块
    urlName: '加盟意向-详情' // 埋点字段，上报归属的模块
  }
};
